import { render, staticRenderFns } from "./ClosedJobs.vue?vue&type=template&id=d4639db2&scoped=true&"
import script from "./ClosedJobs.vue?vue&type=script&lang=js&"
export * from "./ClosedJobs.vue?vue&type=script&lang=js&"
import style0 from "./ClosedJobs.vue?vue&type=style&index=0&id=d4639db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4639db2",
  null
  
)

export default component.exports